import unauthorizedSocket from "@/mixins/unauthorizedSocket";
import customerSocket from "@/mixins/customerSocket";
import {getCookie,setCookie,deleteCookie} from "@/helperFunctions";
import {mapState} from "vuex";
let lastManaged = false;
let manageInterval = false;
export default {
	computed: {
		...mapState('vorbasse', {
			hasPerformedInitialLoad: 'hasPerformedInitialLoad',
			isAuthorized: 'isAuthorized',
			authToken: 'authToken',
			displayName: 'displayName',
			spinTokens: 'spinTokens'
		}),
	},
	mixins: [unauthorizedSocket,customerSocket],
	methods: {
		init(){
			const that = this;
			if(this.$store.state.vorbasse.hasPerformedInitialLoad === false)
			{
				lastManaged = false;
				initUserState(this.$store);
				if(this.authToken !== '')
				{
					if(this.displayName !== '' && this.spinTokens !== false)
					{
						this.$store.commit('vorbasse/setIsAuthorized', true);
						this.$store.commit('vorbasse/setPerformedInitialStateLoad', true);
						this.$vorbasseSocket.destroy();
						this.$vorbasseSocket.setToken(this.authToken);
						this.$vorbasseSocket.ensureSocket('customer',this.initCustomerSocketEvents);
						this.manageAccess();
					}
					else
					{
						this.$store.commit('vorbasse/setIsWaitingForWhoami', true);
						this.$store.commit('vorbasse/setPerformedInitialStateLoad', true);
						this.$vorbasseShopWp.get('?action=whoami&token='+this.authToken)
						.then(response => {
							if(typeof response === 'object' && typeof response.is_authenticated !== 'undefined' && response.is_authenticated === true)
							{
								lastManaged = new Date().getHours();
								setCookie('whoami',response.displayname,24*365);
								setCookie('spin-tokens',response.available_spins.join(','),24*365);
								setCookie('managed',lastManaged,24*365);
								that.$store.commit('vorbasse/setDisplayName', response.displayname);
								that.$store.commit('vorbasse/setSpinTokens', response.available_spins);
								that.$store.commit('vorbasse/setIsAuthorized', true);
								this.$vorbasseSocket.destroy();
								this.$vorbasseSocket.setToken(this.authToken);
								this.$vorbasseSocket.ensureSocket('customer',this.initCustomerSocketEvents);
								this.manageAccess();
							}
							else
							{
								//is not authorized - error message?
								deleteCookie('auth-token');
								deleteCookie('whoami');
								deleteCookie('managed');
								deleteCookie('spin-tokens');
								that.$store.commit('vorbasse/reset');
							}
							that.$store.commit('vorbasse/setIsWaitingForWhoami', false);
						})
						.catch(error => {
							console.log(error);
							that.$store.commit('vorbasse/setIsAuthorized', false);
							that.$store.commit('vorbasse/setIsWaitingForWhoami', false);
						});
					}
				}
				else
				{
					this.$store.commit('vorbasse/setIsAuthorized', false);
					this.$vorbasseSocket.destroy();
					this.$vorbasseSocket.ensureSocket('unauthorized',this.initUnauthorizedSocketEvents);
					this.$store.commit('vorbasse/setPerformedInitialStateLoad', true)
				}
			}
		},
		manageAccess(){
			const that = this;
			that.performManage();
			manageInterval = setInterval(() => {
				that.performManage()
			},1000*60)
		},
		performManage(){
			const that = this;
			const manage = new Date().getHours();
			const cookieManage = getCookie('managed');
			if(this.authToken !== '' && (typeof cookieManage === 'undefined' || Number(cookieManage) !== manage || manage !== lastManaged))
			{
				that.$vorbasseShopWp.get('?action=checkToken&token='+this.authToken)
				.then(response => {
					if(typeof response === 'object' && typeof response.is_authenticated !== 'undefined' && response.is_authenticated === true)
					{
						setCookie('managed',manage,24*365);
						lastManaged = manage;
					}
					else
					{
						clearInterval(manageInterval)
						//is not authorized - error message?
						deleteCookie('auth-token');
						deleteCookie('whoami');
						deleteCookie('managed');
						deleteCookie('spin-tokens');
						that.$vorbasseSocket.destroy();
						that.$store.commit('vorbasse/reset');
						that.$router.push('/')
					}
				})
				.catch(error => {
					console.log(error);
				})
			}
		}
	},
	created()
	{
		this.init();
	},
	watch:{
		hasPerformedInitialLoad(to,from){
			if(to === false)
			{
				this.init();
			}
		}
	}
}

function initUserState(store)
{
	const hasSeenWelcomeScreen = getCookie('hasSeenWelcomeScreen')
	if (typeof hasSeenWelcomeScreen !== 'undefined' && hasSeenWelcomeScreen === 'true')
	{
		store.commit('ux/setHasSeenWelcomeScreen',true)
	}
	//const token = getCookie("auth-token");
	const token = 'fake';
	if (typeof token !== 'undefined')
	{
		store.commit('vorbasse/setAuthToken', token);
		//const whoami = getCookie("whoami");
		const whoami = 'Kenneth';
		if (typeof whoami !== 'undefined')
		{
			store.commit('vorbasse/setDisplayName', whoami);
			//const spins = getCookie("spin-tokens");
			const spins = '1,2,3,4';
			if (typeof spins !== 'undefined')
			{
				if(spins === '')
				{
					store.commit('vorbasse/setSpinTokens', []);
				}
				else
				{
					store.commit('vorbasse/setSpinTokens', spins.split(','));
				}

			}
		}
	}
}
